import PersonRemoveIcon from "@mui/icons-material/PersonRemove";
import { IconButtonProps } from "@mui/material";
import React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { AppToolButton } from "ui/Scripts/source/components/framework/Button/AppToolButton";

interface IRemoveUserToolButtonProps extends IconButtonProps {
    tooltip?: string
}

export const RemoveUserToolButton = (props: IRemoveUserToolButtonProps) => (
    <AppToolButton
        {...props}
        color="error"
        tooltip={props.tooltip ?? Translations.RemoveUser}
        icon={<PersonRemoveIcon />}
    />
);
